import {
  Loader,
  Page,
  Row,
  Spinner,
  toast,
} from '@oliasoft-open-source/react-ui-library';
import { noop } from 'es-toolkit/compat';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { DataViewer } from 'client/components/data-viewer/data-viewer';
import { IObject } from 'common/interfaces/hierarchy-entities';
import { getSharedObject, getSharedObjectUrl } from '../../api-utils';

const errMesg = (msg: any) => {
  toast({
    message: {
      type: 'Error',
      icon: true,
      content: 'error',
      details: msg?.toString(),
    },
  });
};

export const SharedObjectViewer = () => {
  const { preSignedUrlKey } = useParams();

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [response, setResponse] = useState<IObject | null>(null);
  const toggleOff = () => setIsLoading(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { url } = await getSharedObjectUrl(preSignedUrlKey!);
        const blob = await getSharedObject(url);
        setResponse(blob);
      } catch (e) {
        errMesg(e);
      } finally {
        toggleOff();
      }
    };

    fetchData();
  }, [preSignedUrlKey]);

  return (
    <Page padding={false} scroll={false}>
      <Row spacing={0} height="100%">
        {isLoading ? (
          <Loader height="200px" theme="light">
            <Spinner dark />
          </Loader>
        ) : <DataViewer dataObject={response} key={response?.objectid} width="auto" withPaste={false} setSelectedData={noop} />}
      </Row>
    </Page>
  );
};